<template>
  <el-card class="box-card full-screen recharge-apply">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('date')">
          <el-date-picker
            v-model="queryForm.date"
            type="daterange"
            range-separator="~"
            :start-placeholder="$t('startDate')"
            :end-placeholder="$t('endDate')"
            value-format="yyyy-MM-dd"
            size="small"
            unlink-panels
            :clearable="false"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('businessName')">
          <el-select
            v-model="queryForm.businessCode"
            size="small"
            :placeholder="$t('all')"
            clearable
            style="width:200px"
          >
            <el-option
              v-for="op in operations"
              :key="op.code"
              :label="$t(op.label)"
              :value="op.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('status')">
          <el-select
            v-model="queryForm.status"
            size="small"
            :placeholder="$t('all')"
            clearable
            style="width:160px"
          >
            <el-option :label="$t('trading')" :value="1"></el-option>
            <el-option
              :label="$t('completeTransaction')"
              :value="2"
            ></el-option>
            <el-option :label="$t('failureTransaction')" :value="3"></el-option>
            <el-option :label="$t('completeReversal')" :value="5"></el-option>
            <el-option :label="$t('failureReversal')" :value="6"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="isLoading"
            ><i class="el-icon-search"></i> {{ $t("query") }}</el-button
          >
          <el-button size="small" @click="onReset">{{ $t("reset") }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`
      }"
    >
      <el-table
        :data="tableData.records"
        v-loading="isLoading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column
          type="index"
          align="center"
          fixed="left"
          min-width="50"
        ></el-table-column>
        <el-table-column
          :label="$t('creationTime')"
          prop="createTime"
          min-width="200"
          fixed
        >
          <template slot-scope="scope">
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('transactionCode')"
          prop="transactionCode"
          min-width="200"
        ></el-table-column>

        <el-table-column
          :label="$t('businessName')"
          prop="businessName"
          min-width="180"
        >
          <template slot-scope="scope">
            {{ $t(scope.row.businessName) }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('org')"
          prop="customerName"
          min-width="200"
        ></el-table-column>

        <el-table-column :label="$t('Payee')" min-width="200">
          <template slot-scope="scope">
            <template v-if="scope.row.payeeSurname || scope.row.payeeName">
              {{ scope.row.payeeSurname }} {{ scope.row.payeeName }}
              <div v-if="scope.row.payeePhone" class="text-muted">
                {{ scope.row.payeePhone }}
              </div>
            </template>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('amount')" prop="amount" min-width="130">
          <template slot-scope="scope"
            ><span class="franc">FCFA</span>
            {{ scope.row.amount.formatMoney(0) }}</template
          >
        </el-table-column>
        <el-table-column
          :label="$t('serviceCharge')"
          prop="serviceChargeAmount"
          min-width="130"
        >
          <template slot-scope="scope">
            <span class="franc">FCFA</span>
            {{ formatAmount(scope.row.serviceChargeAmount) }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('status')" prop="status" min-width="130">
          <template slot-scope="scope">
            <el-tag :type="statusTag(scope.row.status)" size="small">{{
              $t(statusLabel(scope.row.status))
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="checkRemark"
          :label="$t('checkRemark') + 2"
          show-overflow-tooltip
          width="200"
        />
        <el-table-column :label="$t('extend')" fixed="right" width="160">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click.stop="openPrint(scope.row)"
            >
              {{ $t("printrRceipt") }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[20, 30, 50, 100, 200]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="tableData.total || 0"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />

    <el-dialog
      :title="$t('printrRceipt')"
      :visible.sync="printVisible"
      width="600px"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <print-credentials
        v-if="printParam"
        :param="printParam"
        :isClosePrint.sync="printVisible"
      />
    </el-dialog>
  </el-card>
</template>

<script>
import transactionInfo from "@/api/transactionInfo";
import printCredentials from "@/components/printCredentials";
export default {
  components: { printCredentials },
  name: "advancedCusSingleTransactionsList",
  data() {
    return {
      queryForm: {
        date: null,
        businessCode: "",
        status: null
      },
      operations: [
        { code: "70", label: "transferAccounts" },
        { code: "72", label: "accountRemittanceNotAccount" }
      ],
      queryTableHeight: String,
      tableData: {},
      pageSize: 20,
      currentPage: 1,
      isLoading: false,
      printVisible: false,
      printParam: null
    };
  },
  computed: {
    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    }
  },

  mounted() {
    let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
    this.queryTableHeight = queryTableHeight + "px";
    this.$nextTick(() => {
      this.getList();
    });
  },
  methods: {
    formatAmount(v) {
      if (v === null || v === undefined || v === "") return "0";
      return String(v).formatMoney(0, " ");
    },
    statusLabel(status) {
      const map = {
        1: "trading",
        2: "completeTransaction",
        3: "failureTransaction",
        5: "completeReversal",
        6: "failureReversal"
      };
      return map[status] || "unknown";
    },
    statusTag(status) {
      const map = {
        1: "warning",
        2: "success",
        3: "danger",
        5: "info",
        6: "danger"
      };
      return map[status] || "";
    },
    onQuery() {
      this.currentPage = 1;
      this.getList();
    },
    onReset() {
      const today = new Date();
      const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      this.queryForm = {
        date: [firstOfMonth, today],
        businessCode: "",
        status: null
      };
      this.currentPage = 1;
      this.getList();
    },
    getList() {
      const _this = this;
      _this.isLoading = true;

      const params = {
        current: _this.currentPage,
        size: _this.pageSize
      };
      if (_this.queryForm.date && _this.queryForm.date.length === 2) {
        params.startTime = _this.$manba(_this.queryForm.date[0]).format("ymd");
        params.endTime = _this.$manba(_this.queryForm.date[1]).format("ymd");
      }
      if (_this.queryForm.businessCode)
        params.businessCode = _this.queryForm.businessCode;
      if (_this.queryForm.customerName)
        params.customerName = _this.queryForm.customerName.trim();
      if (_this.queryForm.status !== null && _this.queryForm.status !== "")
        params.status = _this.queryForm.status;

      transactionInfo.advancedCustomerHistory({
        param: params,
        success: res => {
          _this.isLoading = false;
          if (res.code == 200 && res.data) {
            _this.tableData = res.data;
          } else {
            _this.tableData = {};
          }
        }
      });
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getList();
    },
    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    openPrint(row) {
      this.printParam = {
        remittorName: (row.customerName || "").split(" ")[0] || "",
        remittorSurname: (row.customerName || "")
          .split(" ")
          .slice(1)
          .join(" "),
        payeeName: row.payeeName,
        payeeSurname: row.payeeSurname,
        payeeLinkPhone: row.payeePhone,
        transactionCode: row.transactionCode,
        dateTime: row.createTime,
        businessType: row.businessName,
        amount: Number(row.amount || 0),
        serviceChageAmout: Number(row.serviceChargeAmount || 0),
        orgInfoName: row.orgName
      };
      this.printVisible = true;
    }
  }
};
</script>

<style></style>
